// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3t1vd","title":"Header_title__2jmYS","side":"Header_side__3NNiF"};